import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../../api/authApi";
import { useAuth } from "../../context/AuthContext";
import "./RegisterPage.css";

function RegisterPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [dob, setDob] = useState("");
  const [location, setLocation] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const data = await registerUser({ name, email, mobile, password, dob, location, profileImage });
      login(data.user, data.token);
      navigate("/");
    } catch (err) {
      setError(err.message || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="tt-register-wrap">
      <form className="tt-register-card" onSubmit={handleSubmit}>
        <h1 className="tt-register-title">Create your account</h1>
        <p className="tt-register-subtitle">Join Today Talks to save your favorite stories</p>

        {error && <p className="tt-register-error" role="alert">{error}</p>}

        <label className="tt-register-label" htmlFor="register-name">Full name</label>
        <input
          id="register-name"
          type="text"
          className="tt-register-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoComplete="name"
          required
        />

        <label className="tt-register-label" htmlFor="register-email">Email</label>
        <input
          id="register-email"
          type="email"
          className="tt-register-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />

        <label className="tt-register-label" htmlFor="register-mobile">Mobile number</label>
        <input
          id="register-mobile"
          type="tel"
          className="tt-register-input"
          value={mobile}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 15) setMobile(value);
          }}
          inputMode="numeric"
          autoComplete="tel"
          required
        />

        <label className="tt-register-label" htmlFor="register-dob">Date of birth</label>
        <input
          id="register-dob"
          type="date"
          className="tt-register-input"
          value={dob}
          onChange={(e) => setDob(e.target.value)}
          autoComplete="bday"
          required
        />

        <label className="tt-register-label" htmlFor="register-location">
          Location <span className="tt-register-optional">(optional)</span>
        </label>
        <input
          id="register-location"
          type="text"
          className="tt-register-input"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          autoComplete="address-level2"
          placeholder="City, State"
        />

        <label className="tt-register-label" htmlFor="register-password">Password</label>
        <input
          id="register-password"
          type="password"
          className="tt-register-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          minLength={6}
          required
        />

        <label className="tt-register-label" htmlFor="register-confirm">Confirm password</label>
        <input
          id="register-confirm"
          type="password"
          className="tt-register-input"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          autoComplete="new-password"
          minLength={6}
          required
        />

        <label className="tt-register-label" htmlFor="register-photo">
          Profile photo <span className="tt-register-optional">(optional, JPG/PNG)</span>
        </label>
        <input
          id="register-photo"
          type="file"
          className="tt-register-input tt-register-file"
          accept="image/png,image/jpeg"
          onChange={(e) => setProfileImage(e.target.files?.[0] || null)}
        />

        <button type="submit" className="tt-register-submit" disabled={loading}>
          {loading ? "Creating account..." : "Register"}
        </button>

        <p className="tt-register-footer-text">
          Already have an account? <Link to="/login" className="tt-register-link">Log in</Link>
        </p>
      </form>
    </main>
  );
}

export default RegisterPage;
